import { defineMessage } from 'react-intl';

export const defaultErrorMessage = defineMessage({
  id: 'general.error',
  defaultMessage: 'Something went wrong. Try again later or contact us for help.',
});

export const defaultConnectMessage = defineMessage({
  id: 'general.connect',
  defaultMessage: 'Connect',
});

export const defaultGridosMessage = defineMessage({
  id: 'general.gridos',
  defaultMessage: 'GridOS',
});

export const defaultPlatformMessage = defineMessage({
  id: 'general.platform',
  defaultMessage: 'Platform',
});

export const defaultUtilihiveMessage = defineMessage({
  id: 'general.utilihive',
  defaultMessage: 'Utilihive',
});
